export const PENDING = 'PENDING'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'
export const RESET = 'RESET'
export const RELOADING = 'RELOADING'

export const FIELDPENDING = 'GETDISPLAYFIELD_PENDING'
export const FIELDSUCCESS = 'GETDISPLAYFIELD_SUCCESS'

export const USERFIELDPENDING = 'GETUSERFIELD_PENSING'
export const USERFIELDSUCCESS = 'GETUSERFIELD_SUCCESS'

export const AUTOFIELDPENDING = 'GETAUTOFIELD_PENSING'
export const AUTOFIELDSUCCESS = 'GETAUTOFIELD_SUCCESS'

export const AUTOFIELDVALUEPENDING = 'GETAUTOFIELDVALUE_PENDING'
export const AUTOFIELDVALUESUCCESS = 'GETAUTOFIELDVALUE_SUCCESS'

export const FILTERFIELDPENDING = 'GETFILTERFIELD_PENSING'
export const FILTERFIELDSUCCESS = 'GETFILTERFIELD_SUCCESS'

export const SEARCHFILTERFIELDPENDING = 'GETSEARCHFILTERFIELD_PENSING'
export const SEARCHFILTERFIELDSUCCESS = 'GETSEARCHFILTERFIELD_SUCCESS'

export const TYPENEW = 'NEW'
export const TYPEEDIT = 'EDIT'

export const AUDITNAME = 'AUDITNAME'
export const EDITEDNAME = 'EDITEDNAME'
export const TEMPLATENAME = 'TEMPLATENAME'
export const AUDITMETHOD = 'AUDITMETHOD'
export const STARTDATE = 'STARTDATE'
export const DUEDATE = 'DUEDATE'
export const ALLOWSCAN = 'ALLOWSCAN'
export const DUESOONDAYS = 'DUESOONDAYS'
export const ASSETDETAILS = 'ASSETDETAILS'
export const GPSLOCATION = 'GPSLOCATION'
export const CHILDSUCCESS = 'CHILDSUCCESS'
export const SET_DIRECTION = 'SET_DIRECTION'
export const SET_DATES = 'SET_DATES'
